export const MOCK_DB_NAME = 'investira-mock-store';
export const MOCK_DB_VERSION = 1;
export const AVALIACOES_NAMESPACE = 'feature:avaliacoes';
